import { render } from "./ImportBanking.vue?vue&type=template&id=4932309e"
import script from "./ImportBanking.vue?vue&type=script&lang=js"
export * from "./ImportBanking.vue?vue&type=script&lang=js"

import "./ImportBanking.vue?vue&type=style&index=0&id=4932309e&lang=css"
script.render = render

export default script